import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { TaskObject } from 'src/app/models/tasks/tasks-table/task-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { TaskListObject } from 'src/app/models/tasks/tasks-table/task-list-object.model';
import { TaskConverter } from './task.converter';

@Injectable({
    providedIn: 'root'
})
export class TaskListConverter implements Converter<TaskListObject> {

    constructor(private taskConverter: TaskConverter) { }

    convert(input: any): TaskListObject {
        const taskList: TaskListObject = TaskListObject.create();
        if (isNullOrUndefined(input)) {
            return taskList;
        }

        taskList.setPage(input.page);
        taskList.setTotal(input.total);
        if (!isNullOrUndefined(input.elements)) {
            const list = new Array<TaskObject>();
            input.elements.forEach(task => {
                list.push(this.taskConverter.convert(task));
            });
            taskList.setElements(list);
        }
        return taskList;
    }
}
